"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var prose_util_1 = require("@syl-editor/core-utilities/dist/lib/libs/prose-util");
var CURSOR_STYLE = ';cursor: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAYCAMAAACoeN87AAAAh1BMVEUAAAACAgL39/cICAgFBQUAAAADAwMKCgr6+vrn5+fr6+v6+voEBAT19fXm5ubf39+pqanBwcH8/PzOzs76+vrx8fHz8/P29vbh4eHm5ubT09OXl5f///9ZWVkiIiLIyMjGxsY+Pj5LS0uenp4vLy/V1dXk5OSsrKxnZ2eRkZF1dXXj4+ODg4P4y9kGAAAAHHRSTlMACMUDDQYOCuONi8MSt2tJMCryT9OpqKaRezobrP6h8wAAAR9JREFUKM+dk1lygzAMQOMtxoQlS/dKBrMn7f3PVwEFPND0I+/Dg8RD0mjM7nGEZoIOqfwc+0jTVE+RgcAcTQBvbFFOvM7zJvgcIw2uaKF0DuRS5LW1RBmKMQyhdugyMGJWGMciywrkauobZrY2kgxPQQCcFGIPFvb+sNGkSLUo3iDqEvPzqJz5IVF/KEnTIVak0IG35rJV1OFGr7AEKJHULh7KRKRE86gHLPKZAjnrkwEpgV4U6zEqEugRpL+TmXtVEGaQlO0sfK1sVnds7Pf/yim42q9FccjVai/q5WornKlsm4hVFRGX6NFlT7rPSlPb3GgxNnrmHvF7nxYh5A5dDaEaWzGf4TsGzpXQFsut2yDC37tr1O4eSurhD6CaPzWzJeCQ3tPtAAAAAElFTkSuQmCC) 28 10, text;';
var FormatPainterUtil = /** @class */ (function () {
    function FormatPainterUtil(editor, props) {
        var _this = this;
        this.name = 'format_painter';
        this.props = {
            ignoreNodes: [],
            ignoreMarks: [],
            addNodes: [],
            addMarks: []
        };
        this._isApply = false;
        this._isContinuosApply = false;
        this.stopApply = function () {
            _this.isContinuosApply = false;
            _this.isApply = false;
            _this.editor.configurator.emit(core_utilities_1.EventChannel.LocalEvent.ON_CHANGE);
        };
        this.stopApplyOnEsc = function (e) {
            var code = e.keyCode || e.which;
            if (code === 27) {
                _this.stopApply();
                e.stopPropagation();
            }
        };
        this.collectMarks = {};
        this.collectNodes = {};
        this.stashFormat = {
            marks: {},
            nodeAttrs: {}
        };
        this.constructCollectInfo = function () {
            var _a = _this, editor = _a.editor, props = _a.props;
            Object.keys(editor.view.state.schema.marks).forEach(function (markName) {
                var spec = editor.view.state.schema.marks[markName].spec;
                if (props.ignoreMarks.includes(markName) || spec.notStore || spec.notClear)
                    return;
                // false是因为不包含需要重置
                _this.collectMarks[markName] = false;
            });
            props.addMarks.forEach(function (markName) { return (_this.collectMarks[markName] = true); });
            Object.keys(editor.view.state.schema.nodes).forEach(function (nodeName) {
                var nodeType = editor.view.state.schema.nodes[nodeName];
                if (props.ignoreNodes.includes(nodeName))
                    return;
                if (nodeType.isTextblock)
                    _this.collectNodes[nodeName] = true;
            });
            props.addNodes.forEach(function (nodeName) { return (_this.collectNodes[nodeName] = true); });
        };
        this.active = function () {
            return _this.isApply || _this.isContinuosApply;
        };
        this.collectFormat = function () {
            var doc = _this.editor.view.state.doc;
            var _a = _this.editor.view.state.selection, $from = _a.$from, from = _a.from;
            var $end = doc.resolve(from + 1);
            var _marks = {};
            var _nodeAttrs = {};
            ($from.marksAcross($end) || []).forEach(function (mark) {
                if (_this.collectMarks.hasOwnProperty(mark.type.name)) {
                    _marks[mark.type.name] = mark.attrs;
                }
            });
            var parentNode = $from.node();
            if (_this.collectNodes[parentNode.type.name]) {
                var parentSpecAttrs_1 = parentNode.type.spec.attrs || {};
                Object.keys(parentSpecAttrs_1).forEach(function (key) {
                    // @ts-ignore
                    if (parentSpecAttrs_1[key].inherit !== false)
                        _nodeAttrs[key] = parentNode.attrs[key];
                });
            }
            _this.stashFormat.nodeAttrs = _nodeAttrs;
            _this.stashFormat.marks = __assign(__assign({}, _this.collectMarks), _marks);
        };
        this.applyFormat = function () { };
        this.singleApply = function () {
            if (!_this.editor.isFocused)
                return;
            _this.applyFormat();
            _this.isApply = false;
        };
        this.handler = function () {
            if (_this.isContinuosApply || _this.isApply) {
                _this.stopApply();
                return;
            }
            if (!_this.isApply) {
                _this.collectFormat();
                _this.isApply = true;
                _this.editor.configurator.emit(core_utilities_1.EventChannel.LocalEvent.ON_CHANGE);
            }
        };
        this.buttonProps = {
            onDoubleClick: function () {
                _this.collectFormat();
                _this.isContinuosApply = true;
            }
        };
        this.editor = editor;
        Object.assign(this.props, props);
        this.constructCollectInfo();
        this.applyFormat = this._applyFormat.bind(this);
    }
    FormatPainterUtil.prototype.setCursor = function () {
        var style = this.editor.view.dom.getAttribute('style') || '';
        if (!style.includes(CURSOR_STYLE)) {
            this.editor.view.dom.setAttribute('style', style + CURSOR_STYLE);
        }
    };
    FormatPainterUtil.prototype.removeCursor = function () {
        var style = this.editor.view.dom.getAttribute('style') || '';
        if (style.includes(CURSOR_STYLE)) {
            this.editor.view.dom.setAttribute('style', style.replace(CURSOR_STYLE, ''));
        }
    };
    Object.defineProperty(FormatPainterUtil.prototype, "isApply", {
        get: function () {
            return this._isApply;
        },
        set: function (val) {
            if (val === this._isApply)
                return;
            if (!val) {
                document.removeEventListener('mouseup', this.singleApply);
                document.removeEventListener('keyup', this.stopApplyOnEsc);
                this.removeCursor();
            }
            else {
                document.addEventListener('mouseup', this.singleApply);
                document.addEventListener('keyup', this.stopApplyOnEsc);
                this.setCursor();
            }
            this._isApply = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormatPainterUtil.prototype, "isContinuosApply", {
        get: function () {
            return this._isContinuosApply;
        },
        set: function (val) {
            if (val === this._isContinuosApply)
                return;
            if (!val) {
                document.removeEventListener('mouseup', this.applyFormat);
                document.removeEventListener('keyup', this.stopApplyOnEsc);
                this.removeCursor();
            }
            else {
                document.addEventListener('mouseup', this.applyFormat);
                document.addEventListener('keyup', this.stopApplyOnEsc);
                this.setCursor();
            }
            this._isContinuosApply = val;
        },
        enumerable: true,
        configurable: true
    });
    FormatPainterUtil.prototype._applyFormat = function () {
        var _this = this;
        var _a = this.editor.view, state = _a.state, dispatch = _a.dispatch;
        var doc = state.doc;
        var _b = state.selection, $from = _b.$from, $to = _b.$to, empty = _b.empty, from = _b.from, to = _b.to;
        if (empty) {
            return this.stopApply();
        }
        var parentPos = $from.before();
        var tr = state.tr;
        tr = state.tr.setNodeMarkup(parentPos, undefined, this.stashFormat.nodeAttrs);
        tr = prose_util_1.removeMark(doc, tr, from, to);
        Object.keys(this.stashFormat.marks).forEach(function (markName) {
            if (!state.schema.marks[markName] || !_this.stashFormat.marks[markName]) {
                return;
            }
            tr = tr.addMark($from.pos, $to.pos, state.schema.marks[markName].create(_this.stashFormat.marks[markName]));
        });
        dispatch(tr);
    };
    return FormatPainterUtil;
}());
exports.FormatPainterUtil = FormatPainterUtil;
//# sourceMappingURL=format-painter-util.js.map